<template>
  <b-modal id="addToMyCalendarModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('buttons.addToMyCalendar') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" >
        <label
          for="userData"
          class="form-control-label">{{$t('modals.excmtask.date')}}:</label>
        <fg-input>
          <el-date-picker
            :picker-options="{firstDayOfWeek: 1}"
            v-model="date"
            type="date">
          </el-date-picker>
        </fg-input>
      </b-col>
      <b-col cols="6" >
        <label
          for="excmdailyplan_deletedAt"
          class="form-control-label">{{$t('modals.excmtask.timeStartOnCalendar')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('modals.excmtask.timeStartOnCalendar')"
                              v-model="timeStartOnCalendar"
                              format="HH:mm"
                              :right="true"
                              only-time
                              formatted="HH:mm"
        >
        </VueCtkDateTimePicker>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn variant="success" @click="createDailyPlanItem()">{{ $t('buttons.submit') }}</b-btn>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { getUserRoles } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
import { ENTRYPOINT } from '@/config/entrypoint'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'AddToMyCalendarModal',
  components: {
    VueCtkDateTimePicker
  },
  computed: {
    ...mapGetters({
      updated: 'excmdispatchtask/update/updated'
      // task: 'excmtask/show/retrieved'
    }),
    show () {
      return this.$store.state.modals.excmtask.addToMyCalendar.show
    },
    taskIRI () {
      return this.$store.state.modals.excmtask.addToMyCalendar.taskIRI
    },
    close () {
      return this.$store.state.modals.excmtask.addToMyCalendar.close
    },
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    }
  },
  watch: {
    'updated' (val) {
      this.$store.state.modals.excmtask.addToMyCalendar.added = 1
      this.closeModal()
    },
    'show': function (val) {
      this.openModal()
    },
    'taskIRI': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      task: {},
      userData: '/core/public/index.php/api/user_datas/' + getUserRoles().id_userdata,
      User: {},
      date: this.$moment().format('YYYY-MM-DD'),
      timeStartOnCalendar: this.$moment().format('HH:mm')
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.taskIRI) {
        // this.task = Object.assign({}, this.computedTask)
        this.$store.state.modals.excmtask.addToMyCalendar.show = 0
        this.$store.state.modals.excmtask.addToMyCalendar.task = null
        this.$bvModal.show('addToMyCalendarModal')
      }
    },
    async createDailyPlanItem () {
      let params = {
        idUserData: this.userData,
        date: this.$moment(this.date).format('YYYY-MM-DD'),
        timeStartOnCalendar: this.timeStartOnCalendar,
        task: this.taskIRI,
        customOrdering: 1
      }
      const response = await new ApiService('e_x_c_m_daily_plan_items').post(params)
      if (response.status === 201) {
        this.$store.state.modals.excmtask.addToMyCalendar.added = 1
        this.closeModal()
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmtask.addToMyCalendar.close = 0
      }
      this.$bvModal.hide('addToMyCalendarModal')
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // task: {},
      // userData: this.path + 'user_datas/' + getUserRoles().id_userdata,
      //   User: {},
      // date: this.$moment.now(),
      //   timeStartOnCalendar: ''
      this.task = {}
      this.userData = this.path + 'user_datas/' + getUserRoles().id_userdata
      this.User = {}
      this.date = this.$moment().format('YYYY-MM-DD')
      this.timeStartOnCalendar = this.$moment().format('HH:mm')
    }
  }
}
</script>
